import React, { useEffect, useState } from "react";
import ApexCharts from "react-apexcharts";
import { fetchChart } from "../../integration/grafico/fetchChart";
import pixIcon from "../../assets/svg/pix-icon.svg";
import { formatToBRL } from "brazilian-values";

const SalesAreaChart = () => {
  const isMaintenance = true;
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    functionChart();
  }, []);

  async function functionChart() {
    try {
      const resp = await fetchChart();
      if (Array.isArray(resp.series)) setSeries(resp.series);
      if (Array.isArray(resp.categories)) setCategories(resp.categories);
    } catch (erro) {
      console.error("Erro ao buscar dados:", erro);
    }
  }

  const colors = ["#BAA78E", "#4CAF50", "#2196F3", "#FF9800", "#E91E63"];

  const data = {
    series: series,
    options: {
      chart: {
        type: "area",
        height: 350,
        toolbar: { show: false },
        events: {
          dataPointMouseEnter: (_, __, config) =>
            setActiveIndex(config.dataPointIndex),
          dataPointMouseLeave: () => setActiveIndex(null)
        }
      },
      responsive: [
        {
          breakpoint: 640, // Tailwind 'sm' breakpoint
          options: {
            chart: {
              height: 250
            }
          }
        }
      ],

      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 2 },
      xaxis: { categories: categories },
      yaxis: {
        labels: { show: false },
        title: { text: "" }
      },
      fill: { opacity: 0.5 },
      colors: colors,
      legend: { show: false },
      tooltip: {
        shared: true,
        intersect: false,
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          const serieName = w.globals.seriesNames[seriesIndex];
          const rawValue = series[seriesIndex][dataPointIndex];
          const valueBRL = formatToBRL(rawValue / 100);
          return `
            <div style="display: flex; align-items: center; gap: 6px; padding: 6px 10px; background: white; border-radius: 6px; box-shadow: 0 0 8px rgba(0,0,0,0.1);">
              ${
                serieName.toLowerCase() === "pix"
                  ? `<img src="${pixIcon}" alt="PIX" style="width: 20px; height: 20px;" />`
                  : ""
              }
              <span style="font-weight: 600;">${valueBRL}</span>
            </div>
          `;
        }
      }
    }
  };

  const activeLabel = activeIndex !== null ? categories[activeIndex] : null;

  return (
    <div className="relative w-full max-w-4xl mx-auto bg-white lg:bg-transparent p-2 rounded-lg">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
        <h2 className="text-xl sm:text-2xl font-light text-[#0c0c0c] text-center sm:text-left">
          Vendas Mensais
        </h2>
        {activeLabel && (
          <div className="text-center sm:text-right font-medium text-gray-700">
            Visualizando: <span className="text-black">{activeLabel}</span>
          </div>
        )}
      </div>

      <div className={`${!isMaintenance ? "blur-sm opacity-60" : ""}`}>
        <div className="w-full">
          <ApexCharts
            options={data.options}
            series={data.series}
            type="area"
            height={350}
          />
        </div>
      </div>
    </div>
  );
};

export default SalesAreaChart;
